import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ValidatorStatusFieldsFragmentDoc } from './validator-status.graphql';
export type GqlAgValidatorErrorFieldsFragment = { decision: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, boardStatement: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, language: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, signsRegForm: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, availability: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, auths: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null } };

export const AgValidatorErrorFieldsFragmentDoc = gql`
    fragment AgValidatorErrorFields on AgValidatorErrors {
  decision {
    ...ValidatorStatusFields
  }
  boardStatement {
    ...ValidatorStatusFields
  }
  language {
    ...ValidatorStatusFields
  }
  signsRegForm {
    ...ValidatorStatusFields
  }
  availability {
    ...ValidatorStatusFields
  }
  auths {
    ...ValidatorStatusFields
  }
}
    ${ValidatorStatusFieldsFragmentDoc}`;